import { PageInfo } from '@/api/types/pageInfo.types';

export const InvoiceStatus = {
  Paid: 'PAID',
  Unpaid: 'UNPAID',
  Canceled: 'CANCELED',
  Overdue: 'OVERDUE',
  Revoked: 'REVOKED',
} as const;

export type InvoiceStatus = (typeof InvoiceStatus)[keyof typeof InvoiceStatus];

export type InvoiceDto = {
  id: string;
  legacyResourceId: string;
  service: string | null;
  amount: number;
  status: InvoiceStatus;
  invoiceDate: string;
  statusDatetime: string;
  paymentSource: string | null;
  printUrl: string | null;
  discount: number | null;
  vatAmount: number;
  startsAt: string | null;
  expiresAt: string | null;
  period: number | null;
  paidAdsCount: number | null;
  walletAmount: number | null;
  customerName: string | null;
  customerTin: string | null;
  contractNumber: string | null;
};

export type InvoicesVariables = {
  first?: number;
  after?: string | null;
  status?: InvoiceStatus;
};

export type InvoicesConnection = {
  totalCount: number;
  nodes: InvoiceDto[];
  pageInfo: PageInfo;
};

export interface InvoicesResponse {
  currentUserInvoices: InvoicesConnection;
}
